<div class="container content-cart bg-white">
  <div class="row py-3">
    <div class="col float-left" (click)="onBackClick()">
      <!-- <a href="javascript:void(0)" (click)="onBackClick()">
        <i class="fas fa-times fa-lg p-0 font-color-dark-blue"></i>
      </a> -->
      <div class="input-group flex-nowrap">
        <div class="input-group-prepend cursor">
          <i class="fas fa-chevron-circle-left font-size-16" style="color: #1d2124;"></i>
        </div>
      </div>
    </div>
    <div class="col-12 outline-0 text-center mb-3">
      <div class="logo-background-payments text-center" style="margin: 0 auto;width: 26%"></div>
    </div>
  </div>
  <div class="row no-gutters form-group pb-1" *ngIf="alerts.length > 0">
    <div class="col">
      <div *ngFor="let alert of alerts">
        <alert [type]="alert.type" [isOpen]="alert.isOpen" [dismissOnTimeout]="alert.timeout"
          (onClosed)="onClosed(alert)">{{ alert.msg }}</alert>
      </div>
    </div>
  </div>
  <div class="row form-group mb-4 mt-4" *ngIf="environment === 'Testing' || environment === 'Development'">
    <div class="col-1"></div>
    <div class="col-10 p-3 cursor border-radius-4 border background-grey" (click)="onPaymentClick('Reserved')">
      Test Pay
    </div>
    <div class="col-1"></div>
  </div>

  <div class="row border-bottom cursor mx-1" (click)="onPaymentClick('Visa_MasterCard')">
    <div class="col my-2">
      <i class="far icon-card-visa-inline"></i>
    </div>
    <div class="col mt-4">
      <span class="font-weight-bold-500">
        Visa
      </span>
    </div>
  </div>

  <div class="row border-bottom cursor mx-1" (click)="onPaymentClick('Visa_MasterCard')">
    <div class="col my-2">
      <i class="far icon-card-master-inline"></i>
    </div>
    <div class="col mt-4">
      <span class="font-weight-bold-500">
        Master card
      </span>
    </div>
  </div>

  <div class="row border-bottom cursor mx-1" (click)="onPaymentClick('FPX_PERSONAL_ACCOUNT')">
    <div class="col my-2">
      <i class="far icon-fpx-inline"></i>
    </div>
    <div class="col mt-4">
      <span class="font-weight-bold-500">
        FPX
      </span>
    </div>
  </div>

  <div class="row border-bottom cursor mx-1" (click)="onPaymentClick('UPOP')">
    <div class="col my-2">
      <i class="far icon-unionpay-inline"></i>
    </div>
    <div class="col mt-4">
      <span class="font-weight-bold-500">
        Union Pay
      </span>
    </div>
  </div>

  <div class="row border-bottom cursor mx-1" (click)="onPaymentClick('Axiata_Boost')">
    <div class="col my-2">
      <i class="far icon-boost-inline"></i>
    </div>
    <div class="col mt-4">
      <span class="font-weight-bold-500">
        Boost
      </span>
    </div>
  </div>

  <div class="row border-bottom cursor mx-1" (click)="onPaymentClick('Touch_n_Go')">
    <div class="col mt-1 my-2">
      <i class="far icon-touchandgo-inline"></i>
    </div>
    <div class="col mt-4">
      <span class="font-weight-bold-500">
        Touch-n-go
      </span>
    </div>
  </div>

  <div class="row border-bottom cursor mx-1" (click)="onPaymentClick('Maybank_QR')">
    <div class="col my-2">
      <i class="far icon-maybank-inline"></i>
    </div>
    <div class="col mt-4">
      <span class="font-weight-bold-500">
        May Bank QR
      </span>
    </div>
  </div>

  <div class="row border-bottom cursor mx-1" (click)="onPaymentClick('Alipay_Online')">
    <div class="col my-2">
      <i class="far icon-alipay-inline"></i>
    </div>
    <div class="col mt-4">
      <span class="font-weight-bold-500">
        Alipay
      </span>
    </div>
  </div>

  <div class="row border-bottom cursor mx-1" (click)="onPaymentClick('Grab_Pay')">
    <div class="col my-2">
      <i class="far icon-grabpay-inline"></i>
    </div>
    <div class="col mt-4">
      <span class="font-weight-bold-500">
        Grab Pay
      </span>
    </div>
  </div>

  <br>
  <br>
  <br>
  <br>
  <!-- <div class="row form-group mb-4 mt-4" *ngIf="serviceType === 'DINE_IN' && settings">
    <div class="col-1"></div>
    <div class="col-10 p-3 cursor border-radius-4 border background-grey" (click)="onPaymentClick('Reserved')"
      *ngIf="payatCounter || chargetoRoom">
      <div class="input-group">
        <div class="input-group-prepend ml-3 pt-1">
          <i class="far icon-payments icon-cash font-color-dark-blue"></i>
          <label for="" class="col-10 pt-2 cursor font-weight-bold-500 pl-5" *ngIf="payatCounter">
            <span class="h5">Pay at Counter </span><br />(Cash / Card / EWallet)
          </label>
          <h4 for="" class="col-10 pt-2 cursor font-weight-bold-500 pl-4" style="white-space: normal !important;"
            *ngIf="chargetoRoom">
            Charge to <br /> my room
          </h4>
        </div>
      </div>
    </div>
    <div class="col-1"></div>
  </div>

  <div class="row form-group mb-4 mt-4" *ngIf="serviceType === 'COLLECTION' && settings">
    <div class="col-1"></div>
    <div class="col p-3 cursor border-radius-4 border background-grey" (click)="onPaymentClick('Reserved',true)"
      *ngIf="settings.oosrcs_cash_on_collection && settings.oosrcs_cash_on_collection === true">
      <div class="input-group">
        <div class="input-group-prepend ml-3 pt-1">
          <i class="far icon-payments icon-cash font-color-dark-blue"></i>
          <label for="" class="col-10 pt-2 cursor font-weight-bold-500 pl-5">
            <span class="h5">
              Pay at Counter
            </span><br />(Cash / Card / EWallet)
          </label>
        </div>

      </div>
    </div>
    <div class="col-1"></div>
  </div>
  <div class="row form-group mb-4 mt-4" *ngIf="serviceType === 'DELIVERY' && settings">
    <div class="col-1"></div>
    <div class="col p-3 cursor border-radius-4 border background-grey" (click)="onPaymentClick('Reserved',true)"
      *ngIf="settings.oosrcs_cash_on_delivery && settings.oosrcs_cash_on_delivery === true">
      <div class="input-group">
        <div class="input-group-prepend ml-3 pt-1">
          <i class="far icon-payments icon-cash font-color-dark-blue"></i>
          <label for="" class="col-10 pt-2 cursor font-weight-bold-500 pl-5">
            <span class="h5">
              Pay at delivery
            </span><br />(Cash)
          </label>
        </div>

      </div>
    </div>
    <div class="col-1"></div>
  </div>

  <div class="row form-group mb-4 mt-4 ">
    <div class="col-1"></div>
    <div class="col-4 p-2 pt-0 cursor border-radius-4 border background-grey"
      (click)="onPaymentClick('Visa_MasterCard')">
      <div class="input-group">
        <div class="input-group-prepend ml-3 pt-1">
          <i class="far icon-payments icon-card-visa font-color-dark-blue"></i>
        </div>
      </div>
    </div>
    <div class="col-2"></div>
    <div class="col-4 p-2 pt-0 cursor border-radius-4 border background-grey"
      (click)="onPaymentClick('Visa_MasterCard')">
      <div class="input-group">
        <div class="input-group-prepend ml-3 pt-1">
          <i class="far icon-payments icon-card-master font-color-dark-blue"></i>
        </div>
      </div>
    </div>
    <div class="col-1"></div>
  </div>

  <div class="row form-group mb-0  mb-4 mt-4">
    <div class="col-1"></div>
    <div class="col-4 p-2 pt-0 cursor border-radius-4 border background-grey"
      (click)="onPaymentClick('FPX_PERSONAL_ACCOUNT')">
      <div class="input-group ">
        <div class="input-group-prepend ml-3 pt-1 fpx-group">
          <i class="far fa-lg font-color-dark-blue icon-payments icon-fpx"></i>
        </div>
      </div>
    </div>
    <div class="col-2"></div>
    <div class="col-4 p-2 cursor border-radius-4 border background-grey" (click)="onPaymentClick('UPOP')">
      <div class="input-group">
        <div class="input-group-prepend ml-3 pt-1  union-pay-group">
          <i class="far fa-lg font-color-dark-blue icon-payments icon-unionpay"></i>
        </div>
      </div>
    </div>
    <div class="col-1"></div>
  </div>
  <div class="row form-group mb-0 mb-4 mt-4">
    <div class="col-1"></div>
    <div class="col-4 p-2 pt-0 cursor border-radius-4 border background-grey" (click)="onPaymentClick('Axiata_Boost')">
      <div class="input-group">
        <div class="input-group-prepend ml-3 pt-1">
          <i class="far icon-payments icon-boost fa-lg font-color-dark-blue"></i>
        </div>
      </div>
    </div>
    <div class="col-2"></div>
    <div class="col-4 p-2 pt-0 cursor border-radius-4 border background-grey" (click)="onPaymentClick('Touch_n_Go')">
      <div class="input-group">
        <div class="input-group-prepend ml-3 pt-1">
          <i class="far icon-payments icon-touchandgo font-color-dark-blue"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="row form-group mb-0 mb-4 mt-4">
    <div class="col-1"></div>
    <div class="col-4 p-2 pt-0 cursor border-radius-4 border background-grey" (click)="onPaymentClick('Maybank_QR')">
      <div class="input-group">
        <div class="input-group-prepend ml-3 pt-1">
          <i class="far icon-payments icon-maybank font-color-dark-blue"></i>
        </div>
      </div>
    </div>
    <div class="col-2"></div>
    <div class="col-4 p-2 pt-0 cursor border-radius-4 border background-grey" (click)="onPaymentClick('Alipay_Online')">
      <div class="input-group">
        <div class="input-group-prepend ml-3 pt-2">
          <i class="far icon-payments icon-alipay font-color-dark-blue"></i>
        </div>
      </div>
    </div>
  </div>
  <div class="row form-group mb-0">
    <div class="col-1"></div>
    <div class="col-4 p-2 pt-0 cursor border-radius-4 border background-grey" (click)="onPaymentClick('Grab_Pay')">
      <div class="input-group">
        <div class="input-group-prepend ml-3 pt-2">
          <i class="far icon-payments icon-grabpay font-color-dark-blue"></i>
        </div>
      </div>
    </div>
  </div> -->


</div>
<ng-template #paymentfailure>
  <div class="modal-header">
    <span class="font-weight-bold">Payment Failed</span>
    <i class="fas fa-times fa-lg cursor close" (click)="onCloseClick()"></i>
  </div>
  <div class="modal-body rounded">
    <div class="row border-bottom">
      <div class="col text-center">
        We could not process your payment due to {{paymentError}}. The contents of your cart
        have been saved for you
      </div>
    </div>
  </div>
</ng-template>

<!--<ng-template #signup>
  <div class="modal-body rounded">
    <div class="row form-group">
      <div class="col text-center">
        <label for="" class="h3">For Cash terms Sign in/Sign up to continue</label>
      </div>
    </div>
    <div class="row">
      <div class="col text-right">
        <button style="background-color: #1f487c !important;" (click)="onSignUpNowClick()"
          class="btn cart-btn-paylater font-weight-bold-500 box-shadow-none rounded btn-block" type="button">
          SIGN IN
        </button>
      </div>
    </div>
  </div>
</ng-template>-->



<ng-template #signup>
  <div class="modal-header text-center" style="background-color: #264061;">
    <h3 class="modal-title w-100 font-weight-bold"
      style="color: #bfd06a;font-family: Brush-Script-Std-Medium !important;">Sign Up & Enjoy</h3>
  </div>
  <div class="modal-body" style="background-color: #fafafa !important;" [formGroup]="signupform">
    <div class="row form-group">
      <div class="col text-center">
        <label class="font-weight-bold-500 mb-0 h4" style="color: #2f4d74 !important;">Cash Backs</label>
      </div>
    </div>
    <div class="row form-group">
      <div class="col text-center">
        <label class="font-weight-bold-500 mb-0 h4" style="color: #2f4d74 !important;">Discounts</label>
      </div>
    </div>
    <div class="row form-group">
      <div class="col text-center">
        <label class="font-weight-bold-500 mb-0 h4" style="color: #2f4d74 !important;">Referral Discounts</label>
      </div>
    </div>
    <div class="row form-group">
      <div class="col text-center">
        <label class="font-weight-bold-500 mb-0 h4" style="color: #2f4d74 !important;">Other special offers</label>
      </div>
    </div>
    <div class="row form-group">
      <div class="col">
        <ngx-intl-tel-input class="" [cssClass]="'form-control'" [preferredCountries]="preferredCountries" #mobile
          [enableAutoCountrySelect]="false" [enablePlaceholder]="true" [searchCountryFlag]="true"
          [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" [selectFirstCountry]="false"
          [selectedCountryISO]="selectedCountryISO" [maxLength]="15" formControlName="mobile"
          [ngClass]="{'has-error': ((signupform.get('mobile').touched || signupform.get('mobile').dirty) &&  signupform.get('mobile').errors)}"
          [phoneValidation]="true" [separateDialCode]="separateDialCode" name="signupmobile" id="signupmobile">
        </ngx-intl-tel-input>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <button style="background-color: #1f487c !important;" (click)="onSignUpNowClick()"
          class="btn cart-btn-paylater font-weight-bold-500 box-shadow-none rounded btn-block" type="button">
          SIGN UP
        </button>
      </div>
      <!--<div class="col">
        <button style="background-color: #ffffff !important;" class="btn font-weight-bold-500 rounded btn-block border" type="button"
                (click)="onSignupLaterClick()">
          <span style="color: #808080;">No Thanks</span>
        </button>
      </div>-->
    </div>
    <div class="row">
      <div class="col text-center">
        <small>Used in accordance with our <span class="text-primary cursor" (click)="onClickPrivacy()"><u>Privacy
              Policy</u></span></small>
      </div>
    </div>
  </div>
</ng-template>



<ng-template #proceedpayment>
  <div class="modal-body rounded bg-white pb-0">
    <!-- <div class="row">
      <div class="col p-2 border-bottom text-center">
        <label class="">Total Order : <span class="font-weight-bold">
            <span *ngIf="settings && settings.company_currency_position === 'BACK'">
              {{settings.company_currency}}
            </span>
            {{TotalOrderAmount.toFixed(2)}}
            <span *ngIf="settings && settings.company_currency_position === 'FRONT'">
              {{settings.company_currency}}
            </span>
          </span></label>
      </div>
    </div>
    <div class="row" *ngIf="!referralDiscountApplied">
      <div class="col p-2 border-bottom text-center">
        <label class="">Less ({{OfferApplied}}) : <span class="font-weight-bold">
            <span *ngIf="settings && settings.company_currency_position === 'BACK'">
              {{settings.company_currency}}
            </span>
            {{CashbackEarnedAmount.toFixed(2)}}
            <span *ngIf="settings && settings.company_currency_position === 'FRONT'">
              {{settings.company_currency}}
            </span>
          </span></label>
      </div>
    </div>
    <div class="row" *ngIf="referralDiscountApplied">
      <div class="col p-2 border-bottom text-center">
        <label class="">Less (Referral discount {{settings.oosrcs_referral_percentage}}%) : <span class="font-weight-bold">
            <span *ngIf="settings && settings.company_currency_position === 'BACK'">
              {{settings.company_currency}}
            </span>
            {{referralDiscountAmount.toFixed(2)}}
            <span *ngIf="settings && settings.company_currency_position === 'FRONT'">
              {{settings.company_currency}}
            </span>
          </span></label>
      </div>
    </div>
    <div class="row">
      <div class="col p-2 border-bottom text-center">
        <label class="">Payment : <span class="font-weight-bold">
            <span *ngIf="settings && settings.company_currency_position === 'BACK'">
              {{settings.company_currency}}
            </span>
            {{PaymentAmount.toFixed(2)}}
            <span *ngIf="settings && settings.company_currency_position === 'FRONT'">
              {{settings.company_currency}}
            </span>
          </span> </label>
      </div>
    </div>
    <div class="row" *ngIf="NextDiscountApplied !== -1 && NextDiscountApplied !== 0">
      <div class="col p-2 border-bottom text-center">
        <label class="">Next cashback on : <span class="font-weight-bold">{{NextDiscountApplied}}</span> order</label>
      </div>
    </div> -->

    <div class="row" *ngIf="referralDiscountApplied">
      <div class="col p-2 border-bottom text-center">
        <label class="">
          Sub Total : <span class="font-weight-bold">
            <span *ngIf="settings && settings.company_currency_position === 'BACK'">
              {{settings.company_currency}}
            </span>
            {{subTotalAmount.toFixed(2)}}
            <span *ngIf="settings && settings.company_currency_position === 'FRONT'">
              {{settings.company_currency}}
            </span>
          </span>
        </label>
      </div>
    </div>
    <div class="row background-grey" *ngIf="referralDiscountApplied">
      <div class="col p-2 border-bottom text-center">
        <label class="">
          Less <span>
            (Referral discount {{settings.oosrcs_referral_percentage}}%) : <span class="font-weight-bold">
              <span *ngIf="settings && settings.company_currency_position === 'BACK'">
                {{settings.company_currency}}
              </span>
              {{referralDiscountAmount.toFixed(2)}}
              <span *ngIf="settings && settings.company_currency_position === 'FRONT'">
                {{settings.company_currency}}
              </span>
            </span>
          </span>
        </label>
      </div>
    </div>
    <div class="row" *ngFor="let tax of taxList">
      <div class="col p-2 border-bottom text-center" *ngIf="tax.display">
        <label class="">
          {{tax.name}} : <span class="font-weight-bold">
            <span *ngIf="settings && settings.company_currency_position === 'BACK'">
              {{settings.company_currency}}
            </span>
            <span *ngIf="tax.amount.toFixed(2) > 0">
              {{tax.amount.toFixed(2)}}
            </span>
            <span *ngIf="tax.amount.toFixed(2) <= 0">
              0.00
            </span>
            <span *ngIf="settings && settings.company_currency_position === 'FRONT'">
              {{settings.company_currency}}
            </span>
          </span>
        </label>
      </div>
    </div>

    <div class="row" *ngIf="serviceType === 'DINE_IN' && referralDiscountApplied">
      <div class="col p-2 border-bottom text-center">
        <label class="">
          Service Charges({{servicechagePercentage}}%): <span class="font-weight-bold">
            <span *ngIf="settings && settings.company_currency_position === 'BACK'">
              {{settings.company_currency}}
            </span>
            {{serviceCharges.toFixed(2)}}
            <span *ngIf="settings && settings.company_currency_position === 'FRONT'">
              {{settings.company_currency}}
            </span>
          </span>
        </label>
      </div>
    </div>
    <div class="row" *ngIf="serviceType === 'DELIVERY' && referralDiscountApplied">
      <div class="col p-2 border-bottom text-center">
        <label class="">
          Delivery Charges : <span class="font-weight-bold">
            <span *ngIf="settings && settings.company_currency_position === 'BACK'">
              {{settings.company_currency}}
            </span>
            {{deliveryCharges.toFixed(2)}}
            <span *ngIf="settings && settings.company_currency_position === 'FRONT'">
              {{settings.company_currency}}
            </span>
          </span>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col p-2 border-bottom text-center">
        <label class="">
          Total : <span class="font-weight-bold">
            <span *ngIf="settings && settings.company_currency_position === 'BACK'">
              {{settings.company_currency}}
            </span>
            {{TotalOrderAmount.toFixed(2)}}
            <span *ngIf="settings && settings.company_currency_position === 'FRONT'">
              {{settings.company_currency}}
            </span>
          </span>
        </label>
      </div>
    </div>
    <div class="row background-grey" *ngIf="!referralDiscountApplied">
      <div class="col p-2 border-bottom text-center">
        <label class="">
          Less <span class="text-dark">
            ({{OfferApplied}}) : <span class="font-weight-bold">
              <span *ngIf="settings && settings.company_currency_position === 'BACK'">
                {{settings.company_currency}}
              </span>
              {{CashbackEarnedAmount.toFixed(2)}}
              <span *ngIf="settings && settings.company_currency_position === 'FRONT'">
                {{settings.company_currency}}
              </span>
            </span>
          </span>
        </label>
      </div>
    </div>

    <div class="row">
      <div class="col p-2 border-bottom text-center">
        <label class="">
          -Voucher : <span class="font-weight-bold">
            <span *ngIf="settings && settings.company_currency_position === 'BACK'">
              {{settings.company_currency}}
            </span>
            {{voucherAmount.toFixed(2)}}
            <span *ngIf="settings && settings.company_currency_position === 'FRONT'">
              {{settings.company_currency}}
            </span>
          </span>
        </label>
      </div>
    </div>

    <div class="row">
      <div class="col p-2 border-bottom text-center">
        <label class="">
          Payment : <span class="font-weight-bold">
            <span *ngIf="settings && settings.company_currency_position === 'BACK'">
              {{settings.company_currency}}
            </span>
            {{PaymentAmount.toFixed(2)}}
            <span *ngIf="settings && settings.company_currency_position === 'FRONT'">
              {{settings.company_currency}}
            </span>
          </span>
        </label>
      </div>
    </div>

    <div class="row">
      <button type="button" class="btn bg-dark text-white btn-block btn-sm box-shadow-none border-radius-left p-2"
        (click)="onProceedPaymentClick()">
        Proceed
      </button>
    </div>
  </div>
</ng-template>


<app-loading-component></app-loading-component>
<div *ngIf="rhPaymentForm">
  <form method="post" [formGroup]="rhPaymentForm" target="_self">
    <input type="text" name="Revpay_Merchant_ID" formControlName="Revpay_Merchant_ID" hidden="">
    <input type="text" name="Payment_ID" formControlName="Payment_ID" hidden="">
    <input type="text" name="Reference_Number" formControlName="Reference_Number" hidden="">
    <input type="text" name="Amount" formControlName="Amount" hidden="">
    <input type="text" name="Currency" formControlName="Currency" hidden="">
    <input type="text" name="Transaction_Description" formControlName="Transaction_Description" hidden="">
    <input type="text" name="Customer_Name" formControlName="Customer_Name" hidden="">
    <input type="text" name="Customer_Email" formControlName="Customer_Email" hidden="">
    <input type="text" name="Customer_Contact" formControlName="Customer_Contact" hidden="">
    <input type="text" name="Customer_IP" formControlName="Customer_IP" hidden="">
    <input type="text" name="Key_Index" formControlName="Key_Index" hidden="">
    <input type="text" name="Return_URL" formControlName="Return_URL" hidden="">
    <input type="text" name="Signature" formControlName="Signature" hidden="">
  </form>
</div>

<div *ngIf="AmBankPaymentForm">
  <form method="post" [formGroup]="AmBankPaymentForm" target="_self">
    <input type="text" name="MERCHANT_ACC_NO" formControlName="MERCHANT_ACC_NO" hidden="">
    <input type="text" name="MERCHANT_TRANID" formControlName="MERCHANT_TRANID" hidden="">
    <input type="text" name="AMOUNT" formControlName="AMOUNT" hidden="">
    <input type="text" name="TRANSACTION_TYPE" formControlName="TRANSACTION_TYPE" hidden="">
    <input type="text" name="SECURE_SIGNATURE" formControlName="SECURE_SIGNATURE" hidden="">
    <input type="text" name="RESPONSE_TYPE" formControlName="RESPONSE_TYPE" hidden="">
    <input type="text" name="RETURN_URL" formControlName="RETURN_URL" hidden="">
    <input type="text" name="TXN_DESC" formControlName="TXN_DESC" hidden="">
    <input type="text" name="CUSTOMER_ID" formControlName="CUSTOMER_ID" hidden="">
    <input type="text" name="FR_HIGHRISK_EMAIL" formControlName="FR_HIGHRISK_EMAIL" hidden="">
    <input type="text" name="FR_CUSTOMER_IP" formControlName="FR_CUSTOMER_IP" hidden="">
  </form>
</div>